import React from 'react';

export default function Transcript() {
  return (
    <div className="transcript-info">
      <p>To request an official or unofficial transcript, please visit the <a href="https://aimseducation.edu/transcript-request" target="_blank" rel="noopener noreferrer">Transcript Request Page</a>.</p>
    </div>
  );
}